import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { MapMessageProps } from "./MapMessage.props";

/**
 * Displays a text overlay on top of the map canvas
 */
export default function MapMessage({
  displayMessage,
  messageText,
}: MapMessageProps) {
  return (
    <Flex
      hidden={!displayMessage}
      zIndex={1}
      fontSize="sm"
      justifyContent="center"
      position="absolute"
      top="lg"
      height="fit-content"
      width="100%"
      pointerEvents="none"
    >
      <Text
        textAlign="center"
        color="font.dark"
        fontSize={{ base: "xs", md: "sm" }}
        maxWidth={{ base: "150px", md: "100%" }}
      >
        {messageText}
      </Text>
    </Flex>
  );
}
